import React from "react";
import ConfigEditor from "./ConfigEditor";

const DefaultConfigEditorWrapper = () => {
  return <ConfigEditor mode="default" />;
};

export default DefaultConfigEditorWrapper;
